import React, {useState, useEffect, useRef} from 'react';
import {useHistory} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {Badge} from 'primereact/badge';

const ProductionitemListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const [productionItems, setProductionItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [productionStatus, setProductionStatus] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      if (props.detailedSearchQuery) {
        query += (query.includes('?') ? '&' : '?') + props.detailedSearchQuery;
      }
      apiCall('get', '/api/v2/production-item' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setProductionItems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye"
                tooltip={t('view')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  // history.push('/production/production-item/read/' + rowData.id)
                  history.push('/production/productionoverview/read/' + rowData.id)
                }}/>
      </React.Fragment>
    );
  }

  const getProductionStatusSeverity = (status) => {
    const key = status ? status.toString().toUpperCase() : '';
    switch (key) {
      case 'NEW':
        return 'primary';

      case 'SCHEDULED':
        return 'secondary';

      case 'IN_PROGRESS':
        return 'info';

      case 'PAUSED':
      case 'SUSPENDED':
        return 'warning';

      case 'DONE':
        return 'success';

      case 'DELETED':
        return 'danger';

      default:
        return null;
    }
  };

  const getProductionStatusLabel = (status) => {
    if (!status) return '-';
    const key = status.toString().toUpperCase();
    const item = productionStatus.find((statusItem) => statusItem.key === key);
    return item?.value || key;
  };

  const renderProductionStatusBadge = (status) => {
    return (
      <Badge
        value={getProductionStatusLabel(status)}
        severity={getProductionStatusSeverity(status)}
      />
    );
  };

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, props.detailedSearchQuery, window.App.state.rerenderProductionItemList])

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/production-status')
      .then((response) => {
        setProductionStatus(response?.data?.data || []);
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={productionItems} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="status" header={t('columnStatus2')} sortable filter body={(rowData) => renderProductionStatusBadge(rowData?.status)}></Column>
        <Column field="project_number" header={t('columnProjectNumber')} sortable filter></Column>
        <Column field="name" header={t('columnName')} sortable filter></Column>
        <Column field="project_item.name" header={t('columnProjectItem')} sortable filter></Column>
        <Column header={t('columnProjectItem')} sortable filter body={(rowData) => {
          return (
            <>
              {rowData.quantity}{rowData.unit?.name}
            </>
          );
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ProductionitemListComponent);
